import { render } from "./MotivoCita_Cita.vue?vue&type=template&id=dc61f82e"
import script from "./MotivoCita_Cita.vue?vue&type=script&lang=js"
export * from "./MotivoCita_Cita.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__